import { render, staticRenderFns } from "./clientLis-crm.vue?vue&type=template&id=2838b3e2"
import script from "./clientLis-crm.vue?vue&type=script&lang=js"
export * from "./clientLis-crm.vue?vue&type=script&lang=js"
import style0 from "./clientLis-crm.vue?vue&type=style&index=0&id=2838b3e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports